module.exports = __webpack_public_path__ + "img/cloud_top_mobile.f2635864.png";